var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolicyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.477,
    height: 14.417,
    viewBox: "0 0 13.477 14.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_whitelist_2534025",
    transform: "translate(-16 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M36.954,31.4c0-.218-.239-.4-.535-.4H30.535c-.3,0-.535.177-.535.4s.24.4.535.4h5.884C36.715,31.791,36.954,31.614,36.954,31.4Z",
    transform: "translate(-11.233 -22.55)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M33.36,41H30.4a.4.4,0,1,0,0,.791H33.36a.4.4,0,0,0,0-.791Z",
    transform: "translate(-10.598 -30.603)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8929",
    "data-name": "Path 8929",
    d: "M30.4,51.791h2.372a.4.4,0,1,0,0-.791H30.4a.4.4,0,1,0,0,.791Z",
    transform: "translate(-10.642 -38.657)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M27.162,21.4a.4.4,0,0,0-.4-.4H24.4a.4.4,0,1,0,0,.791h2.372A.4.4,0,0,0,27.162,21.4Z",
    transform: "translate(-6.419 -14.496)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M30.4,61.791H33.36a.4.4,0,0,0,0-.791H30.4a.4.4,0,1,0,0,.791Z",
    transform: "translate(-10.598 -46.71)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1050",
    "data-name": "Ellipse 1050",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(18 8.58)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1051",
    "data-name": "Ellipse 1051",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(18 10.55)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1052",
    "data-name": "Ellipse 1052",
    transform: "translate(18 12.529)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1053",
    "data-name": "Ellipse 1053",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(18 14.458)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M51.569,39a2.569,2.569,0,1,0,2.569,2.569A2.569,2.569,0,0,0,51.569,39Zm0,4.348a1.779,1.779,0,1,1,1.779-1.779A1.779,1.779,0,0,1,51.569,43.348Z",
    transform: "translate(-24.662 -29.042)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M57.093,47.115l-.907.906-.511-.511a.4.4,0,1,0-.559.559l.791.791a.4.4,0,0,0,.559,0l1.186-1.186a.4.4,0,1,0-.559-.559Z",
    transform: "translate(-29.476 -35.447)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M26.831,15.468a.436.436,0,0,0-.471.39v.39a.436.436,0,0,1-.471.39H17.413a.436.436,0,0,1-.471-.39V4.948a.436.436,0,0,1,.471-.39h1.024a1.423,1.423,0,0,0,1.33.779h3.767a1.308,1.308,0,0,0,1.413-1.169A1.308,1.308,0,0,0,23.535,3H19.767a1.423,1.423,0,0,0-1.33.779H17.413A1.31,1.31,0,0,0,16,4.948v11.3a1.31,1.31,0,0,0,1.413,1.169H25.89A1.31,1.31,0,0,0,27.3,16.248v-.39A.436.436,0,0,0,26.831,15.468ZM19.767,3.779h3.767a.436.436,0,0,1,.471.39.436.436,0,0,1-.471.39H19.767a.436.436,0,0,1-.471-.39A.436.436,0,0,1,19.767,3.779Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M57.186,12.929a.4.4,0,0,0,.4-.4V8.186A1.187,1.187,0,0,0,56.4,7a.4.4,0,1,0,0,.791.4.4,0,0,1,.4.4v4.348A.4.4,0,0,0,57.186,12.929Z",
    transform: "translate(-30.67 -3.209)",
    fill: "#292d32"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIcon);
export default __webpack_public_path__ + "static/media/policyIcon.0b31f1de.svg";
export { ForwardRef as ReactComponent };